export const aiPromptReducer = (
	state = {
		supportListData: [],
		supportCount: 0
	},
	action
) => {
	switch (action.type) {
		case "AI_PROMPT_LIST":
		case "AI_PROMPT_SUCCESS":
			return {
				...state,
				listData: action.payload.list,
				countData: action.payload.count,

			};

		default:
			return state;
	}
};
